import Big from 'big-js';

export const parseNumber = (value) => {
  if (value === undefined) {
    return undefined;
  }
  const number = Number(value);

  if (isNaN(number)) {
    return undefined;
  }
  return number;
};

export const formatToMax2Decimals = (value) => {
  return removeFractionZeros(new Big(value).toFixed(2));
};

const removeFractionZeros = (numberString) => {
  if (!numberString.includes('.')) {
    return numberString;
  }
  let toRemoveFromBack = 0;
  for (const i of numberString.split('').reverse()) {
    if (i === '0') {
      toRemoveFromBack++;
    } else if (i === '.') {
      toRemoveFromBack++;
      break;
    } else {
      break;
    }
  }
  return numberString.slice(0, numberString.length - toRemoveFromBack);
};

export const formattedNumber = (value, floatCount) => {
  if (value != null) {
    const number = value.toString().replace(',', '.').replace(/\s/g, '');
    return parseNumber(removeFractionZeros(new Big(number).toFixed(floatCount)));
  } else {
    return null;
  }
};
